import React, { useState, useEffect } from 'react';
import { IBusiness } from '../../Types/business';
import { getCompany } from '../../components/API/company';
import LoadingBackdrop from '../../components/LoadingBackdrop';
import Header from '../../components/misc/Header';
import Layout from '../../components/Account/EditBusiness';

export default function EditBusiness() {
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState(null);

  async function getCompanyWrapper() {
    setLoading(true);
    try {
      const company: IBusiness = await getCompany();
      setCompany(company);
    } catch {
      setCompany({});
    }
    setLoading(false);
  }

  useEffect(() => {
    getCompanyWrapper();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <LoadingBackdrop open={loading} />
      {company && (
        <React.Fragment>
          <Header header="Edit Company" />
          <Layout company={company} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
